import React, { useEffect, useState } from "react";
import {
  countries,
  countries_en,
} from "../../../../../utils/constants/nameCountry";
import { useCurrentLanguage } from "../../../../../hooks/useCurrentLanguage";
import { getSurveyJSON } from "../../../../../services/jsons";
import { TOOLTIP_STYLE } from "../../../../../utils/constants/graphConfigs";
import CardSurveys from "../../../../reusable/CardSurveys";

export default function IplIntegration({ isHomePageGraph, isSmall }) {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();

  // Transform data to fit new category structure
  function transformData(data) {
    const subjects = Object.keys(data.answers[language]);
    const countriesList = data.countries;
    const values = data.values;

    const series = countriesList.map((countryCode, index) => ({
      name: language === "en" ? countries_en[countryCode] : countries[countryCode],
      type: "bar",
      data: subjects.map((subject) => values[subject][index]),
    }));

    return { subjects, series };
  }

  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("ipl_integration");

      setData(response);
      setIsLoading(false);
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const { subjects, series } = transformData(data);
      const options = {
        textStyle: {
          fontFamily: "Open Sans",
        },
        color: ["#305EA9", "#6CCDEF", "#8DBA38", "#F4DB4E"],
        tooltip: {
          trigger: "axis",
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value.toFixed(2) + "%",
          axisPointer: {
            type: "shadow",
          },
          formatter: (props) => {
            const divs = [];

            divs.push("<span>" + props[0].axisValue + "</span></br>");
            props.forEach((line) => {
              divs.push(
                "<div>" +
                  line.marker +
                  " " +
                  line.seriesName +
                  ": " +
                  line.data.toFixed(2) +
                  "%</div>"
              );
            });
            return divs.join("");
          },
        },
        legend: {
          top: "2%",
          left: "10%",
          type: "scroll",
          data: series.map((s) => s.name),
        },
        grid: {
          top: "9%",
          left: "5%",
          right: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: subjects.map((subject) => data.answers[language][subject]),
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 15,
          },
        },
        yAxis: {
          name: "Promedio índice de integración  IPL (Más integración ->)",
          nameLocation: "middle",
          nameGap: 50,
          type: "value",
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 15,
          },
        },
        series: series,
      };
      
      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <CardSurveys
      isLoading={isLoading}
      options={options}
      graphTitle={data ? data.question[language] : null}
    />
  );
}